module.exports = __webpack_public_path__ + "static/media/background06.3b62df4e.jpg";